import { render, staticRenderFns } from "./NPS.vue?vue&type=template&id=3aaa132a&"
import script from "./NPS.vue?vue&type=script&lang=js&"
export * from "./NPS.vue?vue&type=script&lang=js&"
import style0 from "./NPS.vue?vue&type=style&index=0&id=3aaa132a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports